var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9987 3.33301C10.7942 3.33301 3.33203 10.7951 3.33203 19.9997C3.33203 29.2042 10.7942 36.6663 19.9987 36.6663C29.2032 36.6663 36.6654 29.2042 36.6654 19.9997C36.6654 10.7951 29.2032 3.33301 19.9987 3.33301ZM27.2229 17.1815C27.356 17.0294 27.4572 16.8523 27.5208 16.6605C27.5844 16.4688 27.6089 16.2662 27.5931 16.0648C27.5772 15.8634 27.5212 15.6672 27.4284 15.4877C27.3355 15.3083 27.2078 15.1492 27.0526 15.0199C26.8974 14.8906 26.7178 14.7936 26.5246 14.7346C26.3314 14.6757 26.1283 14.656 25.9273 14.6767C25.7263 14.6974 25.5315 14.7581 25.3544 14.8552C25.1772 14.9523 25.0212 15.0838 24.8957 15.2421L18.3805 23.0588L15.0093 19.686C14.7235 19.41 14.3408 19.2573 13.9435 19.2608C13.5463 19.2642 13.1663 19.4236 12.8853 19.7045C12.6044 19.9854 12.4451 20.3654 12.4416 20.7627C12.4382 21.16 12.5909 21.5427 12.8669 21.8285L17.4123 26.3739C17.5612 26.5227 17.7394 26.6388 17.9357 26.7149C18.1319 26.791 18.3419 26.8254 18.5521 26.8158C18.7624 26.8063 18.9684 26.753 19.1569 26.6594C19.3454 26.5659 19.5124 26.4341 19.6472 26.2724L27.2229 17.1815Z",
    fill: "url(#paint0_linear_1420_33752)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1420_33752",
    x1: 36.6654,
    y1: 19.9997,
    x2: 3.33203,
    y2: 19.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1245"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2);
export default __webpack_public_path__ + "static/media/Check2.314e9d8413dcd82701debcd78ee160f5.svg";
export { ForwardRef as ReactComponent };